<template>

  <header class="Header">

    <a href="/" class="Brand">
      <div class="inner">
        <AppLogo />
      </div>
    </a>

    <div class="Nav__container">
      <UserNavMobile />
      <EmployeurNav />
      <AppNavAccount />
    </div>
    <MenuToggle />
    <div class="Shortcuts">
      <NotificationsDropdownList />
      <Shortcut icon="phone" @click.prevent="ModalesManager.open('contact')"/>
    </div>

    <EmployeurUserNav v-if="!isProspect" />

  </header>

  <div class="Header__line"></div>

</template>

<script>
import { ModalesManager } from '@/store/modales'
import AppLogo from '@components/app/AppLogo'
import UserNavMobile from "@components/UserNavMobile";
import EmployeurNav from "@components/app/employeur/EmployeurNav";
import AppNavAccount from '@components/app/AppNavAccount'
import MenuToggle from "@components/MenuToggle";
import Shortcut from "@components/Shortcut";
import EmployeurUserNav from "@components/app/employeur/EmployeurUserNav";
import NotificationsDropdownList from "@components/notifications/NotificationsDropdownList";


export default {
  components: {
    NotificationsDropdownList,
    AppLogo,
    UserNavMobile,
    EmployeurNav,
    AppNavAccount,
    MenuToggle,
    Shortcut,
    EmployeurUserNav
  },
  setup(props) {
    return {
      isProspect: false,
      ModalesManager
    }
  }
}
</script>

<style lang="scss">
  @import "~@sass/components/Header";
</style>
